import { validateBirthDateTime } from './dateValidation';

export const BIRTH_DRAFT_KEY = 'ziheng:chart-entry:v1';
export type BirthDraft = {
  version: 1; system: 'ziwei' | 'bazi'; date: string; time: string;
  gender: 'female' | 'male'; timeKnown: boolean; createdAt: number;
};
type Store = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

// A short-lived, same-tab handoff. Never encode birth data in a URL or analytics.
export function parseBirthDraft(raw: string | null, system: BirthDraft['system'], now = Date.now()): BirthDraft | null {
  try {
    const value = JSON.parse(raw || 'null');
    if (!value || value.version !== 1 || value.system !== system ||
      !['female', 'male'].includes(value.gender) || typeof value.timeKnown !== 'boolean' ||
      typeof value.createdAt !== 'number' || !Number.isFinite(value.createdAt) ||
      now - value.createdAt > 15 * 60 * 1000 || value.createdAt > now ||
      (system === 'ziwei' && !value.timeKnown)) return null;
    validateBirthDateTime(value.date, value.time);
    return { version: 1, system, date: value.date, time: value.time, gender: value.gender,
      timeKnown: value.timeKnown, createdAt: value.createdAt };
  } catch { return null; }
}
export function readBirthDraft(store: Store, system: BirthDraft['system']): BirthDraft | null {
  try { return parseBirthDraft(store.getItem(BIRTH_DRAFT_KEY), system); } catch { return null; }
}
export function readBrowserBirthDraft(system: BirthDraft['system']) {
  try { return readBirthDraft(window.sessionStorage, system); } catch { return null; }
}
export function clearBrowserBirthDraft(draft: BirthDraft) {
  try { clearBirthDraft(window.sessionStorage, draft); } catch { /* Use the regular tool form. */ }
}
export function saveBirthDraft(store: Store, draft: BirthDraft) {
  if (!parseBirthDraft(JSON.stringify(draft), draft.system)) throw new RangeError('Invalid chart draft');
  store.setItem(BIRTH_DRAFT_KEY, JSON.stringify(draft));
}
export function clearBirthDraft(store: Store, draft: BirthDraft) {
  try {
    // Do not remove a newer draft from another entry in the same tab.
    if (store.getItem(BIRTH_DRAFT_KEY) === JSON.stringify(draft)) store.removeItem(BIRTH_DRAFT_KEY);
  } catch { /* Storage may be unavailable; the normal tool form still works. */ }
}
